import { render } from "./RecordHistory.vue?vue&type=template&id=0b351fa0"
import script from "./RecordHistory.vue?vue&type=script&lang=js"
export * from "./RecordHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.25.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__